<template>
  <v-app>
    <v-content>
      <Validate />
    </v-content>
  </v-app>
</template>

<script>
import Validate from './components/Validate';

export default {
  name: 'App',
  components: {
    Validate,
  },
  data: () => ({
  }),
};
</script>
